import script from "./Callback.vue?vue&type=script&setup=true&lang=js"
export * from "./Callback.vue?vue&type=script&setup=true&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=78cd9b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78cd9b64"]])

export default __exports__